import { FC } from 'react';
import { emailFormControlInputProps } from '@material-bank/mb-uikit/shared/lib/forms';
import { useIntl } from 'react-intl';

import {
  AuthFormControlInput,
  AuthFormControlInputProps,
} from '../../../../../modules/auth';
import { getEmailFormRules } from '../../../../../shared/lib/forms';
import { translations } from '../../../i18n';
import { PasswordResetFormValues } from '../passwordResetForm';

export interface EmailFieldProps
  extends Partial<
    AuthFormControlInputProps<PasswordResetFormValues, 'email'>
  > {}

export const EmailField: FC<EmailFieldProps> = (props) => {
  const { ...formControlInputProps } = props;

  const intl = useIntl();

  return (
    <AuthFormControlInput
      name="email"
      placeholder={intl.formatMessage(translations.emailPlaceholder)}
      rules={{ ...getEmailFormRules(intl), required: true }}
      {...emailFormControlInputProps}
      {...formControlInputProps}
    />
  );
};
